import { Image } from '@unpic/react';

import down_arrow from '@/assets/gifs/click-to-scroll.gif';
import { Size } from '@/hooks/useScreenSize';
import { cn } from '@/lib/utils';

import { scrollTextClassMap } from './style';

interface scrollProps {
  className?: string;
  isRotate?: boolean;
  size?: Size;
}

export const ScrollContainer: React.FC<React.HTMLAttributes<HTMLDivElement> & scrollProps> = ({
  className,
  isRotate = false,
  size = 'sm',
  ...props
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-xs sm:justify-center',
        className
      )}
      {...props}
    >
      {!isRotate && (
        <div className="text-xs leading-4 text-color-content-text-tertiary">scroll</div>
      )}

      <Image
        src={down_arrow}
        layout="constrained"
        width={24}
        height={28}
        alt="Down arrow"
        className={isRotate ? 'rotate-180' : ''}
        loading="lazy"
      />
      {isRotate && <div className={scrollTextClassMap[size]}>scroll up</div>}
    </div>
  );
};
